<template>
  <v-select
    :items="items"
    item-text="name"
    item-value="id"
    :label="$t('fields.school_types')"
    :error-messages="errors"
    @input="changed"
    :clearable="clearable"
    :multiple="multiple"
  >
    <template v-slot:append-item>
      <div v-intersect="endIntersect" />
    </template>
  </v-select>
</template>
<script>

import { schoolsTypesService } from '../../../utils/services/schoolsTypes.service';

export default {
  name: 'SchoolTypeSelect',
  props: {
    errors: {
      type: [String, Array],
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: null,
      items: [],
      paginations: {
        current_page: 1,
        last_page: 1,
      },
    };
  },
  methods: {
    changed(event) {
      this.$emit('input', event);
    },

    async endIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        if (this.paginations.current_page + 1 <= this.paginations.last_page) {
          const more = await this.fetch(this.paginations.current_page + 1);
          this.items = [...this.items, ...more];
        }
      }
    },

    async fetch(page) {
      return schoolsTypesService.index({
          page: page || 1,
          filters: {
            sortBy: ['name'],
            sortDesc: [false],
          },
        })
      .then(response => {
        const { current_page, last_page } = response.data.meta;
        this.paginations.current_page = current_page;
        this.paginations.last_page = last_page;
        return response.data.data;
      })
      .catch(error => {
          this.handleError(error, this.errors);
          return [];
      });
    },
  },
  async created() {
    this.items = await this.fetch(1);
  },
};
</script>
